import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmSmsMessageTooLongError extends TmApiValidationError {
  public name = 'TmSmsMessageTooLongError'
}
